var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.edit)?_c('markdown',{attrs:{"markdown-config":_vm.markdownConfig}}):_c('markdown-editor',{attrs:{"initial-markdown":_vm.markdownConfig.invocation_markdown,"onupdate":_vm.onupdate}})}
var staticRenderFns = []

export { render, staticRenderFns }